import { Icon, IconName } from '@/icons'
import styles from './BenefitsList.module.scss'

const props: {
  id: number
  icon: IconName
  title: string
  description: string
}[] = [
  {
    id: 1,
    icon: 'fileSearch',
    title: 'Проверка уникальности бренда/товарного знака бесплатно',
    description:
      'Сервис позволяет проверить будущий товарный знак на уникальность, снизить риск отказа Роспатента на старте.',
  },
  {
    id: 2,
    icon: 'fileDigit',
    title: 'Автоматический подбор классов МКТУ',
    description:
      'Возможность по ключевым словам и наименованию товара/услуги подобрать необходимые классы МКТУ с перечнем максимально соответствующих в них позиций.',
  },
  {
    id: 3,
    icon: 'briefcase',
    title: 'Подача онлайн-заявки на регистрацию товарного знака',
    description:
      'Подача заявок в Роспатент из личного кабинета всего за несколько шагов. Все формы и документы заполняются онлайн, что экономит время и упрощает процесс.',
  },
  {
    id: 4,
    icon: 'folderTree',
    title: 'Электронный документооборот и отслеживание статусов',
    description:
      'Сервис позволяет в режиме онлайн отслеживать актуальный статус состояния делопроизводства по заявкам и знакомиться со всеми официальными документами, получаемыми из Роспатента.',
  },
  {
    id: 5,
    icon: 'mailCheck',
    title: 'Создание портфеля товарных знаков',
    description:
      'Все заявки на товарные знаки и регистрации собраны в одном месте. Система автоматического контроляи напоминаний позволяет своевременно продлевать сроки действия правовой охраны товарных знаков.',
  },
]

export const BenefitsList = () => {
  return (
    <div className={styles.container}>
      <div className={styles.backgroundImage} />
      <div className={styles.list}>
        {props.map((prop) => (
          <div key={prop.id} className={styles.item}>
            <div className={styles.iconContainer}>
              <Icon name={prop.icon} className={styles.icon} />
            </div>
            <div className={styles.body}>
              <div className={styles.title}>{prop.title}</div>
              <div className={styles.description}>{prop.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
